<template>
  <div class="banner">
    <div class="stats">
      <div class="stat-item">
        <div class="bigTitle bold">
          <countTo
            :startVal="0"
            separator=","
            :endVal="data.projectCount"
            :duration="1000"
          ></countTo>
        </div>
        <div class="fs18">案例</div>
      </div>
      <div class="stat-item">
        <div class="bigTitle bold">
          <countTo :startVal="0" :endVal="data.readCount" :duration="1000"></countTo>
        </div>
        <div class="fs18">阅读量</div>
      </div>
      <div class="stat-item">
        <div class="bigTitle bold">
          <countTo :startVal="0" :endVal="data.likeCount" :duration="1000"></countTo>
        </div>
        <div class="fs18">点赞数</div>
      </div>
      <div class="stat-item">
        <div class="bigTitle bold">
          <countTo :startVal="0" :endVal="data.shareCount" :duration="1000"></countTo>
        </div>
        <div class="fs18">分享</div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import { fetchHomeStat } from "@/api";
export default {
  components: { countTo },
  data() {
    return {
      data: {
        likeCount: 0,
        projectCount: 0,
        readCount: 0,
        shareCount: 0,
      },
    };
  },
  created() {
    this.getHomeStat();
  },
  methods: {
    getHomeStat() {
      fetchHomeStat().then((res) => {
        this.data = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fs18 {
  font-size: 18px;
}
.bigTitle {
  width: 260px;
  text-align: center;
  font-size: 50px;
  height: 70px;
}
.bold {
  font-weight: bold;
}
.banner {
  width: 100%;
  height: 300px;
  background: url("./../../assets/banner.png") no-repeat bottom center
    rgba($color: #000000, $alpha: 0.4);
  background-size: cover;
  .stats {
    color: #fff;
    width: 1100px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .stat-item {
      text-align: center;
    }
  }
}
</style>